import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { obterArquivoPdfNoticia, obterArquivoPdfNoticiaSuccess, obterArquivoPdfNoticiaFailure, obterArquivoPdfNoticiaFinish } from "../../actions/BancoNoticias/obter-arquivo-pdf-noticia.action";

export interface ObterArquivoPdfNoticiaState {
  response: EstruturaRetornoDadosOutputDto<string> | null;
  error: string[] | null;
}

export const initialState: ObterArquivoPdfNoticiaState = {
  response: null,
  error: null,
};

export const ObterArquivoPdfNoticiaReducer = createReducer(
  initialState,
  on(obterArquivoPdfNoticia, state => ({ ...state, error: null })),
  on(obterArquivoPdfNoticiaSuccess, (state, { response }) => ({ ...state, response, error: null })),
  on(obterArquivoPdfNoticiaFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
  on(obterArquivoPdfNoticiaFinish, state => ({ ...state, response: null, error: null }))
);
